<template>
  <div class="coupon-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('menu.menu-attribute') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createMenuAttribute">
                  <i class="fa fa-plus"></i>&nbsp; {{$t('menu-attribute.new')}}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <b-col xl="6">
                  <div class="pull-left mr-2">
                    <b-input-group>
                      <button type="button" class="btn bg-main border-radius-4px" variant="success" v-on:click="publishMenuAttribute">{{$t('common.publish')}}</button>
                    </b-input-group>
                  </div>
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('common.active')">
                      <b-form-select v-model="filter.active" v-bind:value="filter.active"
                      :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('common.active')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                  <div class="pull-right mr-2" v-if="config_attribute_combo">
                    <b-input-group v-bind:prepend="$t('common.attribute_type')">
                      <b-form-select v-model="filter.type" v-bind:value="filter.type"
                      :options="types[$session.get('lang')]" v-bind:placeholder="$t('common.attribute_type')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col xl="6">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options"
                    position="prepend" v-bind:all="false" v-model="filter.field" prefix="menu-attribute">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">{{$t('common.active')}}</th>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                      <i class="fa fa-sort-amount-asc text-muted"
                      v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted"
                      v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('menu-attribute.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('menu-attribute.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 2">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" @change="updateStatusItem(item)" />
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                      <span v-if="field.render != null"
                      v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="100">
                      <b-button size="sm" variant="primary" v-on:click="editItem(item.uuid)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                  v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->

            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .table thead th:nth-child(1){
    width: 100px;
  }
</style>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import axios from 'axios'
import cSwitch from '../../../components/Switch'
const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'MenuAttributeList',
  components: {
    SelectDropdown,
    cSwitch,
    DataTable
  },
  data: function () {
    return {
      config_attribute_combo: this.$store.getters.config.gms.combo.config.combo_attributes ? this.$store.getters.config.gms.combo.config.combo_attributes : false,
      languages: {},
      type: 'like',
      statuses: [],
      types: [],
      filter: {
        options: [],
        active: 1,
        name: '',
        field: null,
        key: null,
        type: 0
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
          {
            name: 'sequence',
            filter: false,
            sort: false,
            render: (data, row) => {
              return data
            }
          },
          {
            name: 'type',
            filter: false,
            sort: false,
            render: (data, row) => {
              return data === 1 ? this.$t('common.single') : this.$t('common.combo')
            }
          }
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },
      item: {}
    }
  },
  methods: {
    publishMenuAttribute() {
      vm.axios.menu.publishMenuAttribute(function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.refreshData()
      })
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in vm.dataTable.fields) {
        if (vm.dataTable.fields[i].name == field
        && (vm.dataTable.fields[i].sort == null || vm.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (vm.dataTable.sort.field != field) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (vm.dataTable.sort.type == 'asc') {
          vm.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      vm.refreshData()
    },
    /**
     * refresh data for data table
     */
    refreshData () {
      if (cancel != null) {
        cancel()
      }

      //get params
      let _data = {
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage,
        sort_field: this.dataTable.sort.field,
        sort_type: this.dataTable.sort.type
      }
      let active = '';
      if (String(this.filter.active) != '') {
        _data['active'] = this.filter.active
      }

      if (this.filter.type) {
        _data['type'] = this.filter.type
      }

      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        _data[this.filter.field] = this.filter.key.trim()
      }

      //process to send via get method
      let params = '';
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      //remove tail
      params = params.slice(0, -1)
      vm.axios.menu.getMenuAttributeList(params,
        function(response){
          vm.dataTable.items = response.data.data.items
          vm.dataTable.total = response.data.data.pagination.total
        });
    },
    /**
     * move to detail page by uuid
     * @param uuid
     */
    editItem (uuid) {
      this.$router.push({name: 'menu_attribute_edit', params: { id: uuid }})
    },
    /**
     * update active by uuid
     * @param uuid and active
     */
    updateStatusItem (item) {
      vm.axios.menu.updateMenuAttribute(item, function(response){
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.refreshData()
      });
    },
    createMenuAttribute: function(){
      this.$router.push({name: 'menu_attribute_create', params: { id: 'create' }})
    },
    /**
     * get list categories for select box
     */
    getStatusList () {
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ""},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
        }
    },
    setLangType() {
      let langs = Object.keys(vm.$i18n.messages)
      for (let l in langs) {
        vm.types[langs[l]] = [
          {text: vm.$t('common.all', langs[l]), value: 0},
          {text: vm.$t('common.single', langs[l]), value: 1},
          {text: vm.$t('common.combo', langs[l]), value: 2}
        ]
      }
    }
  },
  created: function () {
    vm = this
    vm.setLangType()
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()

    for (let i in vm.dataTable.fields) {
      let field = vm.dataTable.fields[i].name
      if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }

      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true
      && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      }
    }

    vm.$Progress.start()
    vm.getStatusList()
    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    },
    'filter.active': function (val) {
      vm.refreshData()
    },
    'filter.auto_apply': function (val) {
      vm.refreshData()
    },
    'filter.coupon_type': function (val) {
      vm.refreshData()
    },
    'filter.type': function (val) {
      vm.refreshData()
    }
  },
  computed : {
    ranges : function () {
      return vm.format_date_ranges()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/menu-attribute/List.vue